import React, { createContext, useContext, useState, useCallback } from 'react';
import { AuthAPI, AdminMgmtAPI, SuperAdminAPI, setToken, clearToken } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState(null);       // 'superadmin' | 'admin' | null
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loginSuperAdmin = useCallback(async (email, password) => {
    setLoading(true); setError(null);
    try {
      const data = await AuthAPI.superAdminLogin(email, password);
      setToken(data.token);
      const profile = await SuperAdminAPI.getProfile();
      localStorage.setItem('admin_profile', JSON.stringify(profile));
      setUser(profile);
      setRole('superadmin');
      return true;
    } catch (e) {
      setError(e.message);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const loginAdmin = useCallback(async (email, password) => {
    setLoading(true); setError(null);
    try {
      const data = await AuthAPI.adminLogin(email, password);
      setToken(data.token);
      const profile = await AdminMgmtAPI.getSelfProfile();
      localStorage.setItem('admin_profile', JSON.stringify(profile));
      setUser(profile);
      setRole('admin');
      return true;
    } catch (e) {
      setError(e.message);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    clearToken();
    localStorage.removeItem('admin_profile');
    setUser(null);
    setRole(null);
    setError(null);
  }, []);

  return (
    <AuthContext.Provider value={{ role, user, loading, error, loginSuperAdmin, loginAdmin, logout, setError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
